import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { TranslateModule } from '@ngx-translate/core';
import { SubmitMissingInfoV2Component } from 'src/app/modules/quote-assessment/submit-missing-info-v2/submit-missing-info-v2.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { WidgetsModule } from 'src/app/widgets/widgets.module';

/**
 * Eager module for the public quote-assessment missing-info route (OtpGuard, no MsalGuard).
 */
@NgModule({
  declarations: [ SubmitMissingInfoV2Component ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatStepperModule,
    TranslateModule,
    WidgetsModule,
    SharedModule
  ],
  exports: [ SubmitMissingInfoV2Component ]
})
export class PublicSubmitMissingInfoModule {}
